"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ENDPOINTS_1 = __importDefault(require("../../../constants/app/ENDPOINTS"));
const http_service_1 = __importDefault(require("../../../services/http.service"));
const getSessionToken_1 = __importDefault(require("../../../utils/login/getSessionToken"));
/**
 * Client interface to calculate price
 * @returns Promise
 */
const calculateAmount = (reqParam) => {
    const requestId = 'CALCULATOR_INFO';
    // if user not logged in, then do not pass Bearer token
    // if token is passed, api response does not send token again
    const sessionToken = (0, getSessionToken_1.default)();
    const config = {
        data: reqParam,
        headers: {
            Authorization: `Bearer ${sessionToken}`,
        },
    };
    const URL = ENDPOINTS_1.default.BOOKING_SERVICE.CALCULATOR;
    return http_service_1.default.post(requestId, URL, config).then((response) => response.data);
};
exports.default = calculateAmount;
